/**
 * Regex de teléfono en formato E.164 (login dual, DEC-RBAC-079/081). FUENTE ÚNICA compartida por el
 * login (`components/auth/LoginForm`) y las altas de usuario identifier-aware
 * (`components/scoped/identifierFields`, y `ScopedUserForm` en el incremento 2). Centralizada aquí para
 * no divergir cuando el backend afine el formato aceptado (mismo bug class que DTO_LOCAL).
 * Acepta `+` opcional y 10-15 dígitos.
 */
export const PHONE_E164_REGEX = /^\+?\d{10,15}$/;

import { z } from 'zod';

/**
 * Schema zod de un identificador de login (DEC-RBAC-080): acepta email (contiene `@`) O teléfono
 * E.164 (`PHONE_E164_REGEX`). FUENTE ÚNICA compartida por el login (`components/auth/LoginForm`) y
 * la recuperación de contraseña (`components/auth/ForgotPasswordForm`) para que la regla de
 * validación no diverja. El mensaje se muestra tal cual bajo el campo.
 */
export const identifierValueSchema = z
    .string()
    .min(1)
    .refine(
        (v) => v.includes('@') || PHONE_E164_REGEX.test(v),
        'Ingresa un correo o teléfono válido',
    );
